<app-slide-dialog-layout (dismissed)="dismiss()">
    <div left [translate]="'CLOSE'" i18n="@@CLOSE">Close</div>
    <div title [translate]="'CALIBRATION_IMAGES'" i18n="@@CALIBRATION_IMAGES">Calibration images</div>

    <div class="space-y-4">
        <div class="grid grid-cols-2 gap-2" dcListSwitchContainer>
            @for (camera of cameras(); track camera) {
                <button
                    type="button"
                    class="col-span-1"
                    dcListSwitch
                    [selected]="selectedCamera() === $index"
                    dcTypography="geist-14-semibold"
                    (click)="changeView($index)">
                    {{ camera.name }}
                </button>
            }
        </div>

        <div class="flex flex-col items-center gap-4 md:flex-row md:items-start">
            <div class="flex w-full flex-col items-center gap-2 md:w-1/2">
                <div class="w-full text-center" dcTypography="geist-14-semibold" dcColor="bullseye-black">
                    <span [translate]="'CAMERA_VIEWPOINT'" i18n="@@CAMERA_VIEWPOINT">Camera viewpoint</span>
                </div>
                <img class="w-full rounded-lg" [src]="currentCameraImages().default" alt="" />
            </div>
            <div class="flex w-full flex-col items-center gap-2 md:w-1/2">
                <div class="w-full text-center" dcTypography="geist-14-semibold" dcColor="bullseye-black">
                    <span [translate]="'CALIBRATED_RESULT'" i18n="@@CALIBRATED_RESULT">Calibrated result</span>
                </div>
                <img class="w-full rounded-lg" [src]="currentCameraImages().calibration" alt="" />
            </div>
        </div>
    </div>
</app-slide-dialog-layout>
